import { handleActions } from 'redux-actions';
import { Actions, protocolsSuccess, protocolsRequest, protocolsFailure, protocolsReload } from 'actions/protocolActions';
import { Actions as SessionActions } from 'actions/sessionActions';
import { Protocol, ProtocolId, UtcTime } from 'shared/models';

export type State = Readonly<{
    data: Record<ProtocolId, Protocol> | null;
    loading: boolean;
    errorKey: string | null;
    nextFetch: UtcTime;
}>;

export const initialState = Object.freeze<State>({
    data: null,
    loading: false,
    errorKey: null,
    nextFetch: 0,
});

export const protocolsReducer = handleActions({
    [Actions.PROTOCOLS_REQUEST]: (state: State, action: ReturnType<typeof protocolsRequest>) => {
        const { nextFetch } = action.meta;
        return {
            ...state,
            loading: true,
            nextFetch,
        };
    },

    [Actions.PROTOCOLS_SUCCESS]: (state: State, action: ReturnType<typeof protocolsSuccess>) => {
        const data = action.payload.reduce((data, protocol) => {
            data[protocol.id] = protocol;
            return data;
        }, { ...state.data });
        return {
            ...state,
            data,
            errorKey: null,
            loading: false,
        };
    },

    [Actions.PROTOCOLS_FAILURE]: (state: State, action: ReturnType<typeof protocolsFailure>) => {
        return {
            ...state,
            errorKey: action.payload.message,
            loading: false,
        };
    },

    [Actions.PROTOCOLS_RELOAD]: (state: State, action: ReturnType<typeof protocolsReload>) => {
        return {
            ...state,
            nextFetch: 0,
        };
    },

    //
    //  Session Actions
    //
    [SessionActions.LOGOUT_SUCCESS]: () => {
        return initialState;
    },
} as any, initialState);
